import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class CompanyProfile extends Base {
  /**
   * @description List Company API function
   * @returns {Promise<Response>}
   */
  list() {
    const url = this._getFullURL("/company/1");
    return this._secureFetch(url);
  }

  /**
   * @description One Company API function
   * @returns {Promise<Response>}
   */
  getOneCompany(id) {
    const url = this._getFullURL(`/company/${id}`);
    return this._secureFetch(url);
  }

  /**
   * @description One Company API function
   * @returns {Promise<Response>}
   */
  getWhatsappSession(id) {
    const url = this._getFullURL(`/init-session?companyId=${id}`);
    return this._secureFetch(url);
  }

  /**
   * @description Create Location API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload, fileInput) {
    const url = this._getFullURL("/company/");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("file", fileInput);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/company/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }
  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  getService(id) {
    const url = this._getFullURL(`/company-session`);
    return fetch(url, this._generateRequestBody({}));
  }
  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  getDataset() {
    const url = this._getFullURL(`/cmms/ai-doc/dataset`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  startTrial(id) {
    const url = this._getFullURL("/trial-process");
    const payload = { kind: id };
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }

  switchSandbox(id, action) {
    const url = this._getFullURL("/company-session");
    const payload = { service_id: id, action };
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "PUT",
      })
    );
  }
  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  sendRequestTrial(id) {
    const url = this._getFullURL(`/trial-process`);
    return fetch(url, this._generateRequestBody({}));
  }

  prosesExtentRequest(payload) {
    const url = this._getFullURL(`/extend-process`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "PUT",
      })
    );
  }

  cancelExtend(payload) {
    const url = this._getFullURL(`/extend-process`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }

  /**
   * @description Update Location API function
   * @param {string} id
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  update = (id, payload, fileInput) => {
    const url = this._getFullURL(`/company/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    if (fileInput) {
      formdata.append("files", fileInput);
    }

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };

  /**
   * @description Delete machine API function
   * @param {string} uid
   * @returns {Promise<Response>}
   */
  delete = (uid) => {
    const url = this._getFullURL(`/company/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
